const url = process.env.REACT_APP_PROXY_API;
// const url = 'http://192.168.15.4:7000/proxyserv/';
// const url = 'http://192.168.1.18:7000/proxyserv/';

const test = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%ˆ&*()_+{|:?><';
const charlystark = require('crypto');

module.exports = {

  Uwx6GVhZ: function Uwx6GVhZ() {
    var result = '';
    var flowersend = test.length;
    for (var i = 0; i < 64; i++) {
      result += test.charAt(Math.floor(Math.random() * flowersend));
    }
    return result;
  },

  RThzHrsb: function RThzHrsb(text) {
    let iv = charlystark.randomBytes(16);
    let nuninks = charlystark.createCipheriv('aes-128-cbc', Buffer.from("cFE4xActaPH8vuQQ"), iv);
    let result = nuninks.update(text);
    result = Buffer.concat([result, nuninks.final()]);
    return iv.toString('base64') + ':' + result.toString('base64');
  },

  EZcga8qH: function EZcga8qH(w01, w02, w03, functionname, authorization, request, callback) {
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "' + w01 + '","w02": "' + w02 + '","w03": "' + w03 + '","w04": {"function": "' + functionname + '","authorization": "' + authorization + '","request": "' + request + '","referer": "https://wirebit.com/*"}},"cache":"proxycache"}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  QCJQ7DUk: function QCJQ7DUk(w01, w02, w03, functionname, authorization, request, type, data, callback) {
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "' + w01 + '","w02": "' + w02 + '","w03": "' + w03 + '","w04": {"function": "' + functionname + '","authorization": "' + authorization + '","request": "' + request + '","referer": "https://wirebit.com/*","type": "' + type + '","data": "' + data + '"}},"cache":"proxycache"}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  bQk7VZx7: function bQk7VZx7(w01, w02, w03, functionname, authorization, request, callback) {
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "' + w01 + '","w02": "' + w02 + '","w03": "' + w03 + '","w04": {"function": "' + functionname + '","authorization": "' + authorization + '","request": "' + request + '","referer": "https://wirebit.com/*"}},"cache":"proxycache"}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

  Pd4axZxJ: function Pd4axZxJ(w01, w02, w03, functionname, authorization, request, email, password, recaptcha, token, key, callback) {
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json',
      },
      "body": '{ "payload": {"w01": "' + w01 + '","w02": "' + w02 + '","w03": "' + w03 + '","w04": {"function": "' + functionname + '","authorization": "' + authorization + '","request": "' + request + '","referer": "https://wirebit.com/*","email": "' + email + '","password": "' + password + '","recaptcha": "' + recaptcha + '","token": "' + token + '","key": "' + key + '"}},"cache":"proxycache"}'
    })
      .then((response) => response.json())
      .then((responseJson) => {
        callback(responseJson)
      })
      .catch((error) => {
        console.log(error);
      })
  },

};
